<template>
  <div class="messenger-chat-message-info">
    <div class="messenger-chat-message-info__time">{{ formattedTime }}</div>
    <widget-spinner
      v-if="status === MessengerMessageStatus.QUEUE"
      size="16px"
      class="light--text"
    />
    <widget-icon
      v-if="status === MessengerMessageStatus.DELIVERED"
      name="done"
      size="16px"
      class="success--text"
    />
    <widget-icon
      v-if="status === MessengerMessageStatus.SENDING_ERROR"
      name="warning"
      size="16px"
      class="color--orange"
    />
  </div>
</template>

<script lang="ts" setup>
import { MessengerMessageStatus } from '@widgets/messenger/types/chat/message'
import WidgetSpinner from '@widgets/shared/components/WidgetSpinner.vue'
import WidgetIcon from '@widgets/shared/components/WidgetIcon.vue'
import DateTimeService, { DATE_FORMAT } from '@widgets/shared/services/dateTimeService'
import { computed } from '@/composition/vue/compositionApi'

const { messageTime, status } = defineProps<{
  messageTime: string // ISO, example: 2024-08-13T03:17:03+0000
  status?: MessengerMessageStatus
}>()

const formattedTime = computed(() => {
  return DateTimeService.format(messageTime, DATE_FORMAT.TIME)
})
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.messenger-chat-message-info {
  display: inline-flex;
  gap: 2px;

  &__time {
    font-size: $sm-font;
    line-height: 16px;
    white-space: nowrap;
    color: $distinct;
  }
}
</style>
